module.exports = __webpack_public_path__ + "img/finger.d6d0adc1.jpg";